export default __webpack_public_path__ + "static/media/Veeva.3e938f8f.png";